import * as React from 'react'
import {ChangeEvent} from 'react'
import {OverviewTab} from './OverviewState'
import {OverviewAction} from './OverviewActions'
import Card from 'material-ui/Card/Card'
import TextField from 'material-ui/TextField'
import {StaticInputMock} from '../../../View/StaticInputMock'
import {PrintStatus} from '../../../View/InquiryStatusDisplay'
import RaisedButton from 'material-ui/RaisedButton'
import {InquiryHistoryView} from '../InquiryHelperComponents/InquiryHistory'
import Divider from 'material-ui/Divider'
import FileFileUpload from 'material-ui/svg-icons/file/file-upload'
import {InquiryProofCopy} from '../../../Entities/InquiryProofCopy'
import {Downloadable} from '../../../Data/Downloadable'
import {InquiryProofCopyStatus} from '../../../Entities/InquiryProofCopyStatus'
import {DownloadButton} from '../../../View/DownloadButton'
import injectSheet from 'react-jss'
import {WithClasses} from '../../../View/Helper'
import {HttpError, httpErrorToMessage} from '../../../Data/Http'

export function OverviewView({state, dispatch}: {
    state: OverviewTab,
    dispatch: (action: OverviewAction) => void,
}) {
    return (
        <div className="tab__content inquiry-overview">
            <div className="row">
                <div className="column">
                    <Card
                        className="tab__form-card"
                    >
                        <div className="tab__form-header">
                            <h4>Übersicht</h4>
                        </div>
                        <div className="tab__form-content">

                            <TextField
                                className="tab__form-input"
                                floatingLabelText="Kunde"
                                disabled={true}
                                value={state.company.name1}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0,0,0,0.8)'}}
                            />
                            <TextField
                                className="tab__form-input"
                                floatingLabelText="Anfragenummer"
                                disabled={true}
                                value={state.inquiry.inquiryNumber}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0,0,0,0.8)'}}
                            />
                            <div className="tab__form-input">
                                <StaticInputMock
                                    label={'Angebotsstatus'}
                                    text={
                                        <div style={{display: 'flex'}}>
                                            <PrintStatus
                                                inquiryStatus={state.inquiry.offerStatus}
                                            />
                                        </div>}
                                />
                            </div>
                            <TextField
                                className="tab__form-input"
                                floatingLabelText="letzte Aktualisierung"
                                disabled={true}
                                value={state.inquiry.updated.toString()}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0,0,0,0.8)'}}
                            />
                            <TextField
                                className="tab__form-input tab__form-textfield"
                                floatingLabelText="Beschreibung"
                                disabled={true}
                                value={state.inquiry.notes}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0,0,0,0.8)'}}
                                multiLine={true}
                                rows={4}
                                rowsMax={4}
                            />
                            <TextField
                                className="tab__form-input"
                                floatingLabelText="Kundenbetreuer"
                                disabled={true}
                                value={`${state.inquiryUser.firstName} ${state.inquiryUser.lastName}`}
                                underlineDisabledStyle={{display: 'none'}}
                                inputStyle={{color: 'black'}}
                                floatingLabelStyle={{color: 'rgba(0,0,0,0.8)'}}
                            />
                            <Divider className="divider"/>
                            <ProofCopyView
                                proofCopy={state.proofCopy}
                                proofCopyDownload={state.proofCopyDownload}
                                proofCopyStatus={state.inquiry.proofCopyStatus}
                                proofCopyUploadError={state.proofCopyUploadError}
                                dispatch={dispatch}
                            />
                            <Divider className="divider"/>
                            <FinishInquiryView
                                active={state.inquiry.offerStatus === 'approved' && !state.finishInquiryLoading}
                                comment={state.finishInquiryCommentInput}
                                dispatch={dispatch}
                            />
                        </div>
                    </Card>
                </div>
            </div>
            <div className="row">
                <div className="column">
                    <Card
                        className="tab__form-card"
                    >
                        <div
                            className="tab__form-header"
                            style={{marginBottom: '24px'}}
                        >
                            <h4>Statushistorie</h4>
                        </div>
                        <div
                            className="tab__form-content state-history"
                        >
                            <InquiryHistoryView
                                history={state.history}
                                inquiryCreated={state.inquiry.created}
                                inquiryUser={state.inquiryUser}
                            />
                        </div>
                        <div className="state-history__commentary">
                            <div className="state-history__input">
                                <TextField
                                    floatingLabelText="Neuer Kommentar"
                                    multiLine={true}
                                    rows={2}
                                    style={{width: '100%'}}
                                    value={state.historyCommentInput}
                                    onChange={(event, value) => dispatch({
                                        type: 'ChangedHistoryCommentInput',
                                        value: value
                                    })}
                                />
                            </div>
                            <div className="state-history__button">
                                <RaisedButton
                                    label="Absenden"
                                    primary={true}
                                    onTouchTap={() => dispatch({type: 'SubmitHistoryComment'})}
                                />
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    )
}

function ProofCopyView({proofCopy, proofCopyDownload, proofCopyStatus, proofCopyUploadError, dispatch}: {
    proofCopy: InquiryProofCopy | null,
    proofCopyDownload: Downloadable,
    proofCopyStatus: InquiryProofCopyStatus,
    proofCopyUploadError: HttpError | null,
    dispatch: (action: OverviewAction) => void,
}) {
    return (
        <div style={{width: '100%'}}>
            {proofCopyStatus !== 'notRequired' &&
            <div style={{width: '100%'}}>
                <div className="tab__form-header">
                    <h4>Korrekturabzug</h4>
                </div>
                <div className="tab__form-content">
                    <div className="tab__form-input">
                        {proofCopy !== null ?
                            <DownloadButton
                                filename={proofCopy.filename}
                                downloadable={proofCopyDownload}
                                onDownload={() => dispatch({
                                    type: 'DownloadProofCopy'
                                })}
                            />
                            :
                            'Kein Korrekturabzug hinterlegt'}
                    </div>
                    <div className="tab__form-input status-form-input">
                        <StaticInputMock
                            label={''}
                            text={
                                <PrintStatus inquiryStatus={proofCopyStatus}/>}
                        />
                    </div>
                </div>
                <div
                    className="tab__form-buttonset"
                    style={{marginBottom: '24px', display: 'flex', flexDirection: 'row', alignContent: 'flex-end'}}
                >
                    {proofCopyUploadError !== null &&
                    <span style={{marginRight: '16px', padding: '4px 24px', color: '#FF5722'}}>
                            {httpErrorToMessage(proofCopyUploadError)}
                        </span>
                    }
                    <RaisedButton
                        primary={true}
                        style={{marginLeft: 'auto'}}
                        label="Korrekturabzug hochladen"
                        icon={<FileFileUpload/>}
                        onTouchTap={() => {
                            const input =
                                document.getElementById('proof-copy-upload-input')
                            if (input !== null) {
                                input.dispatchEvent(new MouseEvent('click'))
                            }
                        }}
                    />
                    <input
                        className="tab__form-input"
                        type="file"
                        onChange={
                            (event: ChangeEvent<HTMLInputElement>) => {
                                const {files} = event.target
                                if (files === null || files.length < 1) {
                                    return
                                }
                                dispatch({
                                    type: 'UploadProofCopy',
                                    blob: files[0],
                                })
                                event.target.value = ''
                            }}
                        id="proof-copy-upload-input"
                        style={{display: 'none'}}
                    />
                </div>
            </div>
            }
        </div>
    )
}

const finishInquiryStyles = {}

interface FinishInquiryProperties {
    readonly active: boolean
    readonly comment: string
    readonly dispatch: (action: OverviewAction) => void
}

export const FinishInquiryView =
    injectSheet<FinishInquiryProperties>(finishInquiryStyles)(
        ({classes, active, comment, dispatch}: WithClasses<FinishInquiryProperties>) => {
            return (
                <div style={{width: '100%'}}>
                    <div className="tab__form-header">
                        <h4>Anfrage abschließen</h4>
                    </div>
                    <div className="tab__form-content">
                        <TextField
                            fullWidth={true}
                            multiLine={true}
                            value={comment}
                            floatingLabelText="Kommentar"
                            onChange={
                                (event, value) => dispatch({
                                    type: 'FinishInquiryCommentChanged',
                                    value
                                })
                            }
                            disabled={!active}
                            rows={5}
                        />
                    </div>
                    <div className="tab__form-buttonset" style={{display: 'flex'}}>
                        <RaisedButton
                            primary={true}
                            style={{marginLeft: 'auto'}}
                            label="Abschließen"
                            onClick={() => dispatch({type: 'FinishInquiry'})}
                            disabled={!active}
                        />
                    </div>
                </div>
            )
        }
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/InquiryDetails/Overview/OverviewView.tsx